import React from "react";
import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/i18n";
import Navbar from "./components/Navbar";
import DemoBanner from "./components/DemoBanner";
import DemoTools from "./components/DemoTools";
import InvestorLanding from "./pages/InvestorLanding";
import RestaurantDashboard from "./pages/RestaurantDashboard";
import ArtistDashboard from "./pages/ArtistDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import CustomerQR from "./pages/CustomerQR";

function DemoControls() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  return <><DemoBanner /><DemoTools /></>;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
      <DemoControls />
      <Toaster theme="dark" position="top-center" richColors />
      <Routes>
        <Route path="/" element={<InvestorLanding />} />
        <Route path="/a/:artistId" element={<CustomerQR />} />
        <Route
          path="*"
          element={
            <>
              <Navbar />
              <Routes>
                <Route path="/venue" element={<RestaurantDashboard />} />
                <Route path="/artist" element={<ArtistDashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </>
          }
        />
      </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
